export enum MemberTitleExtEnums {
    Retail = 1,
    PreferredCustomer = 2,
    Assistant_Supervisor = 3,
    Supervisor = 4,
    Assistant_Manager = 5,
    Manager = 6,
    Unrecognized_Manager = 7,
    Recognized_Manager = 8,
    Senior_Manager = 9,
    Soaring_Manager = 10,
    Sapphire_Manager = 11,
    Diamond_Sapphire_Manager = 12,
    Diamond_Manager = 13,
    Double_Diamond_Manager = 14,
    Triple_Diamond_Manager = 15,
    Diamond_Centurion_Manager = 16,
    Novus_Customer = 17,
    Guest = 18
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-title.enum.ts